import {
  Component, OnDestroy

  , OnInit
} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {ReplaySubject} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {FacilityService} from '../../../shared/services/facility.service';
import {PartnerFacility} from '../../../shared/interface/partner-facility';
import {MatSnackBar} from '@angular/material/snack-bar';
import {take, takeUntil} from 'rxjs/operators';
import {Ofwca} from '../../../shared/interface/ofwca';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {ListResponse} from '../../../shared/interface/response/list-response';
import {MatDialog} from '@angular/material/dialog';
import {OfwcaAddDialogComponent} from '../../ofwcas/ofwca-add-dialog/ofwca-add-dialog.component';
import {UserApplicationPermission, UserPermissions} from '../../../shared/interface/user-permissions';
import {AuthService} from '../../../shared/services/auth.service';
import {
  FacilitiesVerificationSalesProcessAddComponent
} from "../facilities-verification-sales-process-add/facilities-verification-sales-process-add.component";
import {OFWCA_STATUS_INACTIVE, PARTNER_TAGS_GOOD_AGENT, PARTNER_TAGS_PROFIT} from "../../../shared/services/dict.service";
import {Partner} from "../../../shared/interface/partner";
import {Dictionary} from "../../../shared/interface/dictionary";
import {FacilityDobryAgent, VerificationFacility} from "../../../shared/interface/facility-dobry-agent";
import {FacilityDobryAgentService} from "../../../shared/services/facility-dobry-agent.service";

@Component({
  selector: 'app-facility-details',
  templateUrl: './facility-details.component.html',
  styleUrls: ['./facility-details.component.scss']
})
export class FacilityDetailsComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  addressId?: string = null;
  facility: ReplaySubject<PartnerFacility> = new ReplaySubject(1);
  facilityDobryAgent: ReplaySubject<FacilityDobryAgent> = new ReplaySubject(1);
  facilityDobryAgentObject?: FacilityDobryAgent = null;
  facilityObject?: PartnerFacility = null;
  modify = false;
  modifyFacilityDobryAgent = false;
  profitFacility = true;
  partnerTagGoodAgent = false;
  hasPendingVerification = false;

  ofwcas: ReplaySubject<Ofwca[]> = new ReplaySubject<Ofwca[]>(1);
  ofwca: Ofwca[] = [];
  userPermissions: ReplaySubject<UserPermissions>;
  userApplicationPermission: ReplaySubject<UserApplicationPermission>;

  constructor(
    private route: ActivatedRoute,
    private facilityService: FacilityService,
    private facilityDobryAgentService: FacilityDobryAgentService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.userApplicationPermission = auth.getUserApplicationPermission();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe(params => {
        this.addressId = params.id;
        this.loadFacility();
        this.loadOfwcas();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onTabChange(e: MatTabChangeEvent): void {
    if (e.index === 1) {
      this.loadOfwcas();
    }
  }

  loadOfwcas(): void {
    const val = [];
    this.facilityService.getFacilityOfwcas(this.addressId,)
      .subscribe((ofwcas: ListResponse<Ofwca>) => {
        this.ofwcas.next(ofwcas.items);
        this.ofwca = ofwcas.items;
      });

    this.ofwca.forEach((ofwca: Ofwca) => {
      if (ofwca.status.key !== OFWCA_STATUS_INACTIVE) {
        val.push(ofwca);
      }
    });
    this.ofwca = val;
  }

  loadFacility(): void {
    this.facilityService.get(this.addressId).subscribe((facility: PartnerFacility) => {
      this.facility.next(facility);
      this.facilityObject = facility;
      this.profitFacility = false;
      facility.partners.forEach((partner: Partner) => {
        partner.tags.forEach((tag: Dictionary) => {
          if (tag.key === PARTNER_TAGS_PROFIT) {
            this.profitFacility = true;
          }
          if (tag.key === PARTNER_TAGS_GOOD_AGENT) {
            this.partnerTagGoodAgent = true;
          }
        });
      });
      if (this.partnerTagGoodAgent) {
        this.loadFacilityDobryAgent();
      }
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych placówki', error.status.toString(), {
        duration: 2000
      });
    });
  }

  loadFacilityDobryAgent(): void {
    if (!this.partnerTagGoodAgent || !this.addressId) {
      return;
    }
    this.hasPendingVerification = false;
    this.userApplicationPermission
      .pipe(takeUntil(this.destroyed$))
      .subscribe((permission: UserApplicationPermission) => {
        if (permission.dobryagent.active) {
          this.facilityDobryAgentService.get(this.addressId)
            .pipe(takeUntil(this.destroyed$))
            .subscribe((facility: FacilityDobryAgent) => {
              this.facilityDobryAgent.next(facility);
              this.facilityDobryAgentObject = facility;
              if (facility.hasPendingVerification) {
                this.hasPendingVerification = true
              }
            }, (error: HttpErrorResponse) => {
              this.snack.open('Nie udało się pobrać danych placówki lub brak uprawnień', error.status.toString(), {
                duration: 4000
              });
            });
        }
      });

  }

  addOfwca(): void {
    const dialogRef = this.dialog.open(OfwcaAddDialogComponent, {
      width: '90%',
      data: {facility: this.facilityObject},
      height: '90%',
      maxHeight: '90%',
      panelClass: 'full-height-dialog',
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadOfwcas();
    });
  }

  addVerificationSalesProcess(): void {
    this.loadOfwcas();
    const dialogRef = this.dialog.open(FacilitiesVerificationSalesProcessAddComponent, {
      width: '70%',
      data: {partnerFacility: this.facilityObject, ofwcas: this.ofwca},
      height: '90%',
      maxHeight: '90%',
      panelClass: 'full-height-dialog',
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadOfwcas();
    });
  }

}
